import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Autoplay } from "swiper/modules";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

import { getHappyCustomer } from "../../server/api";

import "swiper/css";
import "swiper/css/thumbs";

const Testimonials = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [happyCustomer, setHappyCustomer] = useState([]);

  const fetchHappyCustomer = async () => {
    try {
      const res = await getHappyCustomer();
      if (res.status === true) {
        setHappyCustomer(res.data);
      }
    } catch (error) {
      console.error("Happy Customer API Error:", error);
    }
  };

  useEffect(() => {
    fetchHappyCustomer();
  }, []);

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="py-3">
          <div className="testiSlider">
            <h2 className="section-title text-center">
              What Our Customer Say?
            </h2>
            <p className="lead text-center">
              Hear what societies are saying about Sevasati
            </p>

            {/* MAIN SLIDER */}
            <Swiper
              modules={[Thumbs, Autoplay]}
              autoplay={{ delay: 5000 }}
              speed={800}
              thumbs={{ swiper: thumbsSwiper }}
              className="testimonial-slider"
            >
              {happyCustomer.map((item) => (
                <SwiperSlide key={item._id}>
                  <div className="testimonial-box text-center">
                    
                    {/* Rating */}
                    <div className="stars">
                      {[...Array(item.rating)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>

                    {/* Description */}
                    <p className="testimonial-text">
                      <FaQuoteLeft className="me-3" />
                      {item.description}
                    </p>

                    {/* Name */}
                    <h4>{item.name}</h4>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* THUMB SLIDER */}
            <Swiper
              onSwiper={setThumbsSwiper}
              modules={[Thumbs]}
              slidesPerView={3}
              spaceBetween={15}
              centeredSlides
              watchSlidesProgress
              className="testimonial-thumbs"
              breakpoints={{
                0: { slidesPerView: 3 },
                768: { slidesPerView: 5 },
              }}
            >
              {happyCustomer.map((item) => (
                <SwiperSlide key={item._id}>
                  <img
                     src={`${process.env.REACT_APP_URL}${item.video}`}
                    alt={item.name}
                    className="testimonial-avatar"
                  />
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
